import { render, staticRenderFns } from "./diantaoLiveRooms.vue?vue&type=template&id=793f8cca&scoped=true"
import script from "./diantaoLiveRooms.vue?vue&type=script&lang=js"
export * from "./diantaoLiveRooms.vue?vue&type=script&lang=js"
import style0 from "./diantaoLiveRooms.vue?vue&type=style&index=0&id=793f8cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793f8cca",
  null
  
)

export default component.exports